const LOADING = 'loading';
const SUCCESS = 'success';
const ERROR = 'error';

export const statusFullMessage = {
  LOADING,
  SUCCESS,
  ERROR,
};
